import { useSyncExternalStore } from 'react';
import { queryClient } from './query';

/** Escritas esperando sinal (9.4): a interface mostra um ponto ocre até sincronizar. */
let pending = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function markQueued() {
  pending++;
  emit();
}

export function usePendingWrites(): number {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => pending,
  );
}

export function initOfflineSync() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.addEventListener('message', (e) => {
    const t = (e.data as { type?: string })?.type;
    if (t === 'kaizen-synced') {
      pending = 0;
      emit();
      void queryClient.invalidateQueries();
    }
    if (t === 'kaizen-navigate') {
      const url = (e.data as { url: string }).url;
      window.location.assign(url);
    }
  });
  window.addEventListener('online', () => {
    navigator.serviceWorker.controller?.postMessage({ type: 'kaizen-replay' });
  });
}
